module.exports = __webpack_public_path__ + "img/espm.c6277474.svg";